"use strict";

var _classCallCheck = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RepulseDiv = void 0;

var RepulseBase_1 = require("./RepulseBase");

var RepulseDiv = /*#__PURE__*/function (_RepulseBase_1$Repuls) {
  _inherits(RepulseDiv, _RepulseBase_1$Repuls);

  function RepulseDiv() {
    var _this;

    _classCallCheck(this, RepulseDiv);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RepulseDiv).call(this));
    _this.selectors = [];
    return _this;
  }

  _createClass(RepulseDiv, [{
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(RepulseDiv.prototype), "load", this).call(this, data);

      if (data === undefined) {
        return;
      }

      if (data.ids !== undefined) {
        this.ids = data.ids;
      }

      if (data.selectors !== undefined) {
        this.selectors = data.selectors;
      }
    }
  }, {
    key: "ids",
    get: function get() {
      if (this.selectors instanceof Array) {
        return this.selectors.map(function (t) {
          return t.replace("#", "");
        });
      } else {
        return this.selectors.replace("#", "");
      }
    },
    set: function set(value) {
      if (value instanceof Array) {
        this.selectors = value.map(function () {
          return "#".concat(value);
        });
      } else {
        this.selectors = "#".concat(value);
      }
    }
  }]);

  return RepulseDiv;
}(RepulseBase_1.RepulseBase);

exports.RepulseDiv = RepulseDiv;